import { render, staticRenderFns } from "./UserFeedBack.vue?vue&type=template&id=c823b1aa&scoped=true"
import script from "./UserFeedBack.vue?vue&type=script&lang=js"
export * from "./UserFeedBack.vue?vue&type=script&lang=js"
import style0 from "./UserFeedBack.vue?vue&type=style&index=0&id=c823b1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c823b1aa",
  null
  
)

export default component.exports